// import ORCH_BASE_URL from '../config/orchConfig';
import orchestratorAxios from './orchestratorAxios';
import axiosInstance from './axiosInstance';
import BASE_URL from '../config/apiConfig';
import ORCH_BASE_URL from '../config/orchConfig';

// const ORCH_API_URL = `${ORCH_BASE_URL}`;

// User Management

export const createOrganization = (payload) =>
  axiosInstance.post('/admin/organizations/', payload).then((r) => r.data);

export const getOrganizations = async () => {
  try {
    const response = await axiosInstance.get('/admin/organizations/');
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Failed to fetch organizations:', error);
    return [];
  }
};

export const getOrganizationById = async (orgId) => {
  if (!orgId) throw new Error('Organization ID is required');
  const { data } = await axiosInstance.get(
    `/admin/organizations/${encodeURIComponent(orgId)}`,
  );
  return data;
};

export const updateOrganization = async (orgId, body) => {
  if (!orgId) throw new Error('Organization ID is required');
  const { data } = await axiosInstance.put(
    `/admin/organizations/${encodeURIComponent(orgId)}`,
    body,
  );
  return data;
};

export async function createUser(body) {
  const { data } = await axiosInstance.post(`${BASE_URL}/admin/users/`, body);
  return data;
}

export async function updateUser(userId, body) {
  const { data } = await axiosInstance.put(
    `${BASE_URL}/admin/users/${userId}`,
    body,
  );
  return data;
}

export async function getUserById(userId) {
  const { data } = await axiosInstance.get(`${BASE_URL}/admin/users/${userId}`);
  return data;
}

export const fetchUsers = async (token) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/admin/users/`, {
      params: { per_page: 100 },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.users;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const fetchSuperAdmins = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/admin/users`, {
      params: {
        per_page: 100,
        role: 'SuperAdmin',
      },
    });
    return response.data.users || [];
  } catch (error) {
    console.error('Error fetching SuperAdmins:', error);
    throw error;
  }
};

export const assignUserToOrganization = async (orgId, userId) => {
  if (!orgId) throw new Error('Organization ID is required');
  if (!userId) throw new Error('User ID is required');

  const { data } = await axiosInstance.post(
    `/admin/organizations/${encodeURIComponent(orgId)}/users`,
    { user_id: userId },
  );
  return data;
};

export const updateOrganizationTrialConfig = async (orgId, config) => {
  if (!orgId) throw new Error('Organization ID is required');
  const { data } = await axiosInstance.put(
    `/admin/organizations/${encodeURIComponent(orgId)}/trial-config`,
    config,
  );
  return data;
};

export const extendOrganizationTrial = async (orgId, extensionData) => {
  if (!orgId) throw new Error('Organization ID is required');
  const { data } = await axiosInstance.post(
    `/admin/organizations/${encodeURIComponent(orgId)}/extend-trial`,
    extensionData,
  );
  return data;
};

export const updateUserTrialConfig = async (userId, config) => {
  if (!userId) throw new Error('User ID is required');
  const { data } = await axiosInstance.put(
    `${BASE_URL}/admin/users/${userId}/trial-config`,
    config,
  );
  return data;
};

export const extendUserTrial = async (userId, extensionData) => {
  if (!userId) throw new Error('User ID is required');
  const { data } = await axiosInstance.post(
    `${BASE_URL}/admin/users/${userId}/extend-trial`,
    extensionData,
  );
  return data;
};

//Announcements
export async function createAnnouncement(payload) {
  const { data } = await axiosInstance.post(
    `${BASE_URL}/admin/announcements/`,
    payload,
  );
  return data;
}

export async function getAnnouncements(params = {}) {
  const { data } = await axiosInstance.get(`${BASE_URL}/admin/announcements/`, {
    params,
  });

  // Support axios {data}, direct arrays, or various keyed arrays
  const body = data?.data ?? data;

  const announcements = Array.isArray(body)
    ? body
    : Array.isArray(body?.announcements)
      ? body.announcements
      : Array.isArray(body?.results)
        ? body.results
        : Array.isArray(body?.items)
          ? body.items
          : [];

  return announcements;
}

export async function deleteAnnouncement(announcement_id) {
  if (!announcement_id) throw new Error('announcement_id is required');

  const url = `${BASE_URL}/admin/announcements/${encodeURIComponent(announcement_id)}`;
  const { data } = await axiosInstance.delete(url); // trailing slash not used per your spec

  // return something meaningful; many APIs send { success: true, message: '...' }
  return {
    ok: data?.success ?? true,
    message: data?.message ?? 'Deleted',
    data,
  };
}

export async function getAnnouncementById(announcement_id) {
  if (!announcement_id) throw new Error('announcement_id is required');
  const { data } = await axiosInstance.get(
    `${BASE_URL}/admin/announcements/${encodeURIComponent(announcement_id)}`,
  );
  const body = data?.data ?? data;
  return body?.announcement ?? body;
}

export async function updateAnnouncement(announcement_id, payload) {
  if (!announcement_id) throw new Error('announcement_id is required');
  const { data } = await axiosInstance.put(
    `${BASE_URL}/admin/announcements/${encodeURIComponent(announcement_id)}`,
    payload,
  );
  return data?.data ?? data;
}

//Application settings

export const getWorkflowSettings = async (orgId) => {
  const { data } = await axiosInstance.get(`${BASE_URL}/admin/settings/`, {
    params: { org_id: orgId },
  });
  return data;
};

export const getTimezoneOptions = async (orgId) => {
  const { data } = await axiosInstance.get(
    `${BASE_URL}/admin/settings/timezones`,
    {
      params: { org_id: orgId },
    },
  );
  return data;
};

export const getDateFormatOptions = async (orgId) => {
  const { data } = await axiosInstance.get(
    `${BASE_URL}/admin/settings/date-formats`,
    {
      params: { org_id: orgId },
    },
  );
  return data;
};

export const saveWorkflowSettings = async (orgId, payload) => {
  // payload shape: { workflow_settings: { default_timezone, also_show_times_in_utc, secondary_timezone, date_format } }
  const { data } = await axiosInstance.put(
    `${BASE_URL}/admin/settings/`,
    payload,
    {
      params: { org_id: orgId },
    },
  );
  return data;
};

export const getPublicTimezoneSettings = async () => {
  const { data } = await axiosInstance.get(`${BASE_URL}/settings/timezone`);
  return data;
};

export const updatePublicTimezoneSettings = async (payload) => {
  const { data } = await axiosInstance.put(
    `${BASE_URL}/settings/timezone`,
    payload,
  );
  return data;
};

export const getPublicTimezoneOptions = async () => {
  const { data } = await axiosInstance.get(`${BASE_URL}/settings/timezones`);
  return data;
};

export const getPublicDateFormatOptions = async () => {
  const { data } = await axiosInstance.get(`${BASE_URL}/settings/date-formats`);
  return data;
};

// Audit Logs
export const getAuditLogs = async (opts = {}) => {
  const { signal, params } = opts;
  const { data } = await orchestratorAxios.get(`${BASE_URL}/admin/audit-logs/`, {
    signal,
    params,
  });
  return data;
};

export const getCurrentUserProfile = async () => {
  try {
    const { data } = await axiosInstance.get(`${BASE_URL}/auth/profile`);
    return data;
  } catch (error) {
    console.error('Error fetching user profile:', error);

    let errorMessage = 'Failed to load profile. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        if (typeof responseData.detail === 'string') {
          errorMessage = responseData.detail;
        } else if (typeof responseData.detail === 'object') {
          errorMessage =
            responseData.detail.message ||
            responseData.detail.error ||
            JSON.stringify(responseData.detail);
        }
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      } else if (responseData?.error) {
        errorMessage =
          typeof responseData.error === 'string'
            ? responseData.error
            : JSON.stringify(responseData.error);
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const updateCurrentUserProfile = async (profileData) => {
  try {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/auth/profile`,
      profileData,
    );
    return data;
  } catch (error) {
    console.error('Error updating user profile:', error);

    let errorMessage = 'Failed to update profile. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        if (typeof responseData.detail === 'string') {
          errorMessage = responseData.detail;
        } else if (typeof responseData.detail === 'object') {
          errorMessage =
            responseData.detail.message ||
            responseData.detail.error ||
            JSON.stringify(responseData.detail);
        }
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      } else if (responseData?.error) {
        errorMessage =
          typeof responseData.error === 'string'
            ? responseData.error
            : JSON.stringify(responseData.error);
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const getContactSubmissions = async (params = {}) => {
  try {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/admin/contact-submissions/`,
      { params },
    );
    return data;
  } catch (error) {
    console.error('Error fetching contact submissions:', error);

    let errorMessage = 'Failed to fetch contact submissions. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const getContactSubmissionById = async (submissionId) => {
  if (!submissionId) throw new Error('Submission ID is required');

  try {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/admin/contact-submissions/${submissionId}`,
    );
    return data;
  } catch (error) {
    console.error('Error fetching contact submission:', error);

    let errorMessage = 'Failed to fetch contact submission. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const updateContactSubmission = async (submissionId, updateData) => {
  if (!submissionId) throw new Error('Submission ID is required');

  try {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/admin/contact-submissions/${submissionId}`,
      updateData,
    );
    return data;
  } catch (error) {
    console.error('Error updating contact submission:', error);

    let errorMessage = 'Failed to update contact submission. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const deleteContactSubmission = async (submissionId) => {
  if (!submissionId) throw new Error('Submission ID is required');

  try {
    const { data } = await axiosInstance.delete(
      `${BASE_URL}/admin/contact-submissions/${submissionId}`,
    );
    return data;
  } catch (error) {
    console.error('Error deleting contact submission:', error);

    let errorMessage = 'Failed to delete contact submission. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const getContactSubmissionActivity = async (submissionId) => {
  if (!submissionId) throw new Error('Submission ID is required');

  try {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/admin/contact-submissions/${submissionId}/activity`,
    );
    return data;
  } catch (error) {
    console.error('Error fetching contact submission activity:', error);

    let errorMessage =
      'Failed to fetch contact submission activity. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

// Public Reviews
export const getPublicReviews = async (params = {}) => {
  try {
    const { data } = await orchestratorAxios.get(
      `${ORCH_BASE_URL}/admin/reviews/get-public-reviews`,
      { params },
    );
    // Handle different response formats
    return Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.reviews)
          ? data.reviews
          : [];
  } catch (error) {
    console.error('Error fetching public reviews:', error);

    let errorMessage = 'Failed to fetch public reviews. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

export const approvePublicReview = async (reviewId, approved) => {
  if (!reviewId) throw new Error('Review ID is required');

  try {
    const { data } = await orchestratorAxios.patch(
      `${ORCH_BASE_URL}/admin/reviews/approve/${reviewId}`,
      { approved },
    );
    return data;
  } catch (error) {
    console.error('Error approving public review:', error);

    let errorMessage = 'Failed to approve review. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

// Get Approved Reviews (for public display)
export const getApprovedReviews = async (params = {}) => {
  try {
    const { data } = await orchestratorAxios.get(
      `${ORCH_BASE_URL}/admin/reviews/get-approved-reviews`,
      { params },
    );
    // Handle different response formats
    return Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.reviews)
          ? data.reviews
          : [];
  } catch (error) {
    console.error('Error fetching approved reviews:', error);

    let errorMessage = 'Failed to fetch approved reviews. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }
};

// Send Review Response Email
export const sendReviewResponseEmail = async (emailData) => {
  if (!emailData?.to_emails || !Array.isArray(emailData.to_emails) || emailData.to_emails.length === 0) {
    throw new Error('to_emails is required and must be a non-empty array');
  }
  if (!emailData?.subject || !emailData?.body) {
    throw new Error('subject and body are required');
  }

  try {
    const payload = {
      to_emails: emailData.to_emails,
      subject: emailData.subject,
      body: emailData.body,
      ...(emailData.is_html !== undefined && { is_html: emailData.is_html }),
      ...(emailData.cc_emails && Array.isArray(emailData.cc_emails) && emailData.cc_emails.length > 0 && { cc_emails: emailData.cc_emails }),
      ...(emailData.bcc_emails && Array.isArray(emailData.bcc_emails) && emailData.bcc_emails.length > 0 && { bcc_emails: emailData.bcc_emails }),
      ...(emailData.attachments && Array.isArray(emailData.attachments) && emailData.attachments.length > 0 && { attachments: emailData.attachments }),
    };

    const { data } = await axiosInstance.post('/email/send', payload);
    return data;
  } catch (error) {
    console.error('Error sending review response email:', error);

    let errorMessage = 'Failed to send email. Please try again.';

    if (error.response) {
      const responseData = error.response.data;

      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData?.detail) {
        errorMessage =
          typeof responseData.detail === 'string'
            ? responseData.detail
            : JSON.stringify(responseData.detail);
      } else if (responseData?.message) {
        errorMessage = responseData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    throw new Error(errorMessage);
  }

};
